export const downloadFile = response => {
  const contentType = response.headers['content-type'] || 'application/pdf';
  const blob = new Blob([response.data], { type: contentType });

  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);

  // Prefer RFC-6266 Content-Disposition filename; fall back to non-standard 'filename' header.
  const disposition = response.headers['content-disposition'];
  const match = disposition && /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(disposition);
  const filename = (match && decodeURIComponent(match[1])) || response.headers['filename'];
  if (filename) link.download = filename;

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const downloadExcelFile = response => {
  const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

  // Create a link element
  const link = document.createElement('a');

  // Set the download attribute to the file name you want
  link.href = window.URL.createObjectURL(blob);
  link.download = response.headers['filename']; // Set the file name

  // Append link to body, click to start download, and then remove the link
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
